import { forEach, keys } from 'lodash';
import validateValue from './validateValue.util';

/**
 * Mandatory fields with error message if string is falsy
 */
export const mandatoryFields = {
  email: 'Email address',
  firstName: 'First name',
  lastName: 'Last name',
  address: 'Address',
  company: 'Company',
  industry: 'Industry',
  refer: 'Referral Id',
  businessSegment: 'Business segment',
};

/**
  * @param {string} abbreviation - abbreviation of selected country
  */
const validateOrgInput = (inputValues, abbreviation) => {
  const errorMsgs = {};
  forEach(keys(inputValues),
    (field) => {
      const errorMsg = validateValue({ mandatoryFields }, field, inputValues[field], abbreviation);
      errorMsgs[field] = errorMsg;
      if (errorMsgs[field] !== '') {
        errorMsgs.hasValidationErrors = true;
      }
    });
  return errorMsgs;
};

export default validateOrgInput;
